import React from "react"
import { ui } from "../../../shared/styles/uiSystem"

export default function DragConflictDrawer({
  conflict,
  alternatives,
  loading,
  specialtyLabel,
  onApply,
  onClose
}) {
  if (!conflict) return null

  return (
    <div
      style={{
        position: "fixed",
        bottom: 20,
        right: 20,
        width: 420,
        maxWidth: "calc(100vw - 24px)",
        zIndex: 9999
      }}
    >
      <div
        style={{
          ...ui.card,
          padding: 16,
          borderLeft: "4px solid #f59e0b",
          boxShadow: "0 18px 36px rgba(15,23,42,0.14)"
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: 10,
            alignItems: "flex-start",
            marginBottom: 12
          }}
        >
          <div>
            <div
              style={{
                display: "inline-flex",
                padding: "5px 9px",
                borderRadius: 999,
                background: "#fff7ed",
                border: "1px solid #fed7aa",
                color: "#c2410c",
                fontSize: 10,
                fontWeight: 900,
                letterSpacing: 0.5,
                textTransform: "uppercase",
                marginBottom: 8
              }}
            >
              Conflicto operativo
            </div>

            <div
              style={{
                fontSize: 18,
                fontWeight: 900,
                color: "#0f172a",
                lineHeight: 1.1
              }}
            >
              Conflicto al mover o redimensionar cita
            </div>
          </div>

          <button
            onClick={onClose}
            style={{
              ...ui.secondaryButton,
              minHeight: 32,
              padding: "0 10px"
            }}
          >
            Cerrar
          </button>
        </div>

        <div
          style={{
            ...ui.softCard,
            padding: 12,
            marginBottom: 12
          }}
        >
          <div style={{ fontWeight: 800, color: "#0f172a" }}>
            {conflict.title || "Se detectó un conflicto en agenda"}
          </div>

          {conflict.message && (
            <div
              style={{
                fontSize: 13,
                color: "#9a3412",
                marginTop: 6,
                lineHeight: 1.45
              }}
            >
              {conflict.message}
            </div>
          )}
        </div>

        <div
          style={{
            fontSize: 12,
            color: "#64748b",
            fontWeight: 800,
            marginBottom: 10
          }}
        >
          Alternativas sugeridas
        </div>

        {loading ? (
          <div
            style={{
              ...ui.softCard,
              padding: 12,
              color: "#64748b",
              fontSize: 13
            }}
          >
            Buscando opciones...
          </div>
        ) : !alternatives.length ? (
          <div
            style={{
              ...ui.softCard,
              padding: 12,
              color: "#64748b",
              fontSize: 13
            }}
          >
            No se encontraron alternativas automáticas.
          </div>
        ) : (
          <div style={{ display: "grid", gap: 10 }}>
            {alternatives.map((alt, idx) => (
              <div
                key={idx}
                style={{
                  ...ui.card,
                  padding: 12
                }}
              >
                <div style={{ fontWeight: 800, color: "#0f172a" }}>
                  {alt.doctorName} · {specialtyLabel(alt.specialty)}
                </div>

                <div style={{ fontSize: 13, color: "#475569", marginTop: 4 }}>
                  {new Date(alt.startTime).toLocaleString("es-MX")}
                </div>

                <div style={{ fontSize: 12, color: "#64748b", marginTop: 4, lineHeight: 1.4 }}>
                  {alt.compatibilityReason}
                </div>

                <button
                  onClick={() => onApply(alt)}
                  style={{
                    ...ui.secondaryButton,
                    marginTop: 8,
                    background: "#dbeafe",
                    border: "1px solid #bfdbfe",
                    color: "#1d4ed8"
                  }}
                >
                  Aplicar alternativa
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}